import React from 'react'
import { connect } from 'react-redux'
import { utcToLocalDate } from '../../../helpers/timeHelper'
import { UserVehicleLink } from '../userVehicleLinkHOC'
import CardWrapper from './CardWrapper'

const VehicleWithRefiListItem = ({ refi, internalUrl }) => {
  const fields = [
    {
      label: 'Approval date',
      value: refi.qualifiedAt && utcToLocalDate(refi.qualifiedAt),
    },
    { label: 'VIN', value: refi.vehicle.vin },
    { label: 'Refi ID', value: refi.refiId },
    { label: 'Loan ID', value: refi.loanId },
    { label: 'External ID', value: refi.externalId },
    { label: 'Decision', value: refi.decision },
    { label: 'Loan status', value: refi.status },
    { label: 'Total amount', value: refi.totalMonthlyPayment },
    { label: 'Credit tier', value: refi.tier },
    { label: 'Days to expiration', value: refi.daysToExpiration },
  ]
    .filter(({ value }) => value)
    .map(({ label, value }) => (
      <li key={label}>
        {label}: {value}
      </li>
    ))

  return (
    <CardWrapper
      leftText={`ID ${`${refi.vehicle.id}`}`}
      pillText={refi.status && refi.status.toUpperCase()}
      internalUrl={internalUrl}
    >
      {fields}
    </CardWrapper>
  )
}

const mapDispatchToProps = (dispatch) => ({ dispatch })

export default connect(
  null,
  mapDispatchToProps
)(UserVehicleLink(VehicleWithRefiListItem))
